import { useTranslation } from "react-i18next";
import { SearchInput } from "@/components/custom/SearchInput";

export const SearchBar = ({ onChange }: { onChange: (v: string) => void }) => {
  const { t } = useTranslation("membersGroups");

  return (
    <SearchInput
      containerClassName="w-full sm:w-[300px]"
      name="members-groups-search"
      placeholder={t("search.placeholder")}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
